
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaTrash,FaPlus } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import {Mandate} from '../../compnents/formcomp';
import { Message } from 'primereact/message';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


const SubClientmerger = ({tabname}) => {
    const toast = useRef(null);
    const msgs = useRef(null);
    const [formData, setFormData] = useState({
        client: '',
        dsubclient:'',
        mainsubclient:'',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [budgethrs,setbudgethrs] = useState([]); 
    const [clientcomp,setClientcomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
    const [subclientdata,setSubclientdata] = useState({}); 
    const [popupvisible,setVisibility] = useState(false);
    const [adjustmentvalues,setadjustmentvalues] = useState({});
    const [budgetobjdata,setbudgetobjdata] = useState({});
    const [ismerging,setmergerloader] = useState(true);
    const [selectedclient,setclient] = useState('');
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
        getallclient();
        // getbudgethours();
    },[]);

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));
    
            if(name == 'client'){
                setclient(name);
                getallsubclient({client:value}); 
                // setbudgethrs(0);
            }

        }catch(e){
            console.log(e);
        }
        
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (formData.client == '') {
          newErrors.client = 'Client name is required';
          valid = false;
        }

        if (formData.subclient == '') {
            newErrors.subclient = 'Subclient name is required';
            valid = false;
        }
        
        if (formData.budgethours == '') {
            newErrors.budgethours = 'Budgethours is required';
            valid = false;
        }

        setErrors(newErrors);
        return valid; 
    }

    const reject = () => {
      //toast.current.show({ severity: 'warn', summary: 'Client merger', detail: 'Canceled', life: 3000 });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
       
        try{
            console.log("form data");
            // console.log(formData);
            let dsubclient = JSON.parse(formData.dsubclient);
            let mainsubclient = JSON.parse(formData.mainsubclient);
            let obj ={
                'client':formData.client,
                'dsubclient':dsubclient.subclient,  
                'mainsubclient':mainsubclient.subclient  
            }; 

            confirmDialog({
                message: 'Are you sure you want to proceed?',
                header: 'SubClient merger',
                icon: 'pi pi-exclamation-triangle',
                defaultFocus: 'accept',
                accept: () => { 
                    subclientmerger(obj);
                },
                 //accept,
                reject
             });
           
            // addbudgethours({obj});
        }catch(e){
           console.log(e);
        }
    };

    function subclientmerger(obj){
        setmergerloader(false);
        timesheetService.subclientmerger(obj).then((response)=>{
           if(response.status == 200){
                console.log(response);   
                toast.current.show({severity:'success', summary: "Subclientmerger", detail:`Subclient has been merged!`, life: 3000});  
                setmergerloader(true);
                getallsubclient({client:selectedclient});
            }else{
               console.log(response);
               toast.current.show({severity:'error', summary: "Subclientmerger", detail:`Not merged!`, life: 3000});  
               setmergerloader(true);
               getallsubclient({client:selectedclient});
            }   
        }).catch((error)=>{
             console.log(error); 
             toast.current.show({severity:'error', summary: "Subclientmerger", detail:`Error!`, life: 3000});  
             setmergerloader(true);
             getallsubclient({client:selectedclient});
        });
    }

    function addbudgethours({obj}){
       adminService.addbudgethours({obj:obj}).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Budget", detail:`Budget hours updated successfully!`, life: 3000});
                getbudgethours();
            }else{
                toast.current.show({severity:'error', summary: "Budget", detail:`Budget hours not updated`, life: 3000});
            }
           setFormData({budgethours:'',subclient:'',client:''});
           
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Budget", detail:`Budget hours not updated`, life: 3000});
            console.log("error");
            console.log(error);
        });
    } 

    function getbudgethours(){
        let emparr = [];
        setloading(false);
        adminService.getbudgethours().then((response)=>{
            setDatacomp(response.data.data);
            setDatacomptemp(response.data.data);
            setloading(true);
            setDatastate(true);
        }).catch((error)=>{
            setDatacomp([]);
            setDatacomptemp([]); 
            setloading(true);
            setDatastate(true);
        });   
    }

    function getbudgethourstemp(obj){
        let emparr = [];
        setloading(false);
        adminService.getbudgethourstemp({formdata:obj}).then((response)=>{
            setDatacomp(response.data.data);
            setDatacomptemp(response.data.data);
            setloading(true);
            setDatastate(true);
            console.log(obj,"budget hours");
            setbudgetobjdata(obj);
        }).catch((error)=>{
            setDatacomp([]);
            setDatacomptemp([]); 
            setloading(true);
            setDatastate(true);
        });   
    }

    function getallclient(){
        let emparr = [];
        adminService.getallclient().then((response)=>{
           console.log(response.data.data);
           response.data.data.forEach((value,index)=>{
            if(value.client != ''){
                emparr.push(<option value={value.client}>{value.client}</option>);
            }
           
           });
           setClientcomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }

    function getallsubclient({client}){
        let emparr = [];
        adminService.getallsubclienttemp({client:client}).then((response)=>{
           // console.log(response.data.data);
           if(response.status == 200){
              response.data.data.forEach((value,index)=>{
                emparr.push(<option value={JSON.stringify(value)}>{value.subclient}</option>);
               });
           }           
           setsubClientscomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }

    const searchclients = (e) =>{
        let value = e.target.value; 
        let _userdatalist = datacomptemp;
        
        const searchRegexClient    = new RegExp(value.toLowerCase());
        const searchRegexSubclient = new RegExp(value.toLowerCase());
        const foundItems = _userdatalist.filter(item => 
          // (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
         (searchRegexClient.test(item.client.toLowerCase()) || searchRegexSubclient.test(item.subclient.toLowerCase()))
        );
      
        if (foundItems.length > 0) {
            console.log('items found.');
            setDatacomp(foundItems);
        } else {
            console.log('No items found.');
            setDatacomp([]);
        }
    }

    function handlechangeddata(e){
        const { name, value } = e.target;
        setadjustmentvalues((prevData) => ({
        ...prevData,
        [name]: value,
        }));
         
        let newval = 0;
        if(name == 'budget_hours2'){
            if(value.length > 0){
                newval = (parseFloat(adjustmentvalues['budget_hours_temp']) + parseFloat(value));
                setadjustmentvalues((prevData)=> ({...prevData,budget_hours:newval}))
            }else{
                setadjustmentvalues((prevData)=> ({...prevData,budget_hours:adjustmentvalues['budget_hours_temp']}));
            }
        }
        

        console.log(name);
    }

    function handleSubmitform2(e){
        e.preventDefault(); 
        // console.log('adjustment values');
        // console.log(adjustmentvalues);
        let obj = {
            'data': adjustmentvalues
        };
        timesheetService.updatebudgethours(obj).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Budget", detail:`Budget hours updated successfully!`, life: 3000});
                getbudgethourstemp(budgetobjdata);
                setVisibility(false); 
            }else{
                toast.current.show({severity:'error', summary: "Budget", detail:`Budget hours not updated`, life: 3000}); 
                setVisibility(false);
            }
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Budget", detail:`Error`, life: 3000});
            setVisibility(false);  
        }); 
    }

    function editbudgethrs(obj){
      console.log("edit budget hours"); 
    //   console.log(obj); 
      setadjustmentvalues(obj);

      setVisibility(true); 
    }

    function resetbudgethours(id){
        let obj = {'id':id};
        timesheetService.resetbudgethours(obj).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Budget", detail:`Budget hours reset successfully!`, life: 3000});
                getbudgethourstemp(budgetobjdata);
            }else{
                toast.current.show({severity:'error', summary: "Budget", detail:`Budget hours not reset!`, life: 3000});  
            }
        }).catch(()=>{
            toast.current.show({severity:'error', summary: "Budget", detail:`error!`, life: 3000});  
        });
        
    }

    function displaydata(){
        let emparr = [];
        datacomp.forEach((value,index)=>{
            // console.log(value.name);
            emparr.push(<tr>
                 <td>{value.id}</td>
                 <td>{value.client}</td>
                 <td>{value.subclient}</td>
                 <td>{value.budget_hours}</td>
                 <td>{value.created_at}</td>
                 <td>{value.allowed != 'allowed' ? 'Disabled' : 'Enabled'}</td>
                 <td>
                    <button className='btn btn-success' onClick={() => editbudgethrs(value)}><FaEdit/></button>
                    <button className='btn btn-danger' onClick={()=>resetbudgethours(value.id)}><FaTrash/></button>
                 </td>
            </tr>);
        });    
        return emparr;
    }

 return (
        <>
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
            <Toast ref={toast} />
            <ConfirmDialog /> 
            <div className="card flex justify-content-center">
                <Message severity="info" text="Please update first subclient budget hours from edit button if you see multiple subclient" />
            </div>
            <br/>
               
              <form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className="col-md-3">
                        <label className='pull-left'>Client</label>
                        <br/>
                        <select className='custom-dropdown-style' value={formData.client} name="client" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Client</option>
                           {clientcomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div>
                    <div className="col-md-3">
                        <label className='pull-left'>Duplicate Sub-client</label>
                        <br/>
                        <select className='custom-dropdown-style' value={formData.subclient} name="dsubclient" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Subclient</option>
                           {subclientscomp}
                        </select>
                        {errors.subclient && <span className='error'>{errors.subclient}</span>}
                    </div>
                    <div className="col-md-3">
                        <label className='pull-left'>Main Sub-client</label>
                        <br/>
                        <select className='custom-dropdown-style' value={formData.subclient} name="mainsubclient" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Subclient</option>
                           {subclientscomp}
                        </select>
                        {errors.subclient && <span className='error'>{errors.subclient}</span>}
                    </div>
                    
                    <div className="col-md-3 col-sm-12">
                        <div className='button-wrapper-style'>
                            {/* {console.log(subclientdata)} */}
                             <Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style col-md-12' >{!ismerging ? (loader.Loadermd()) : (<></>) }</Button>
                        </div>
                     </div>
                </div>
                </form>
            </div>

            <Dialog header="Edit Budget hours" position='top' visible={popupvisible} style={{ width: '60vw' }} onHide={() => setVisibility(false)}>
               <form onSubmit={(e) => handleSubmitform2(e)}>
               <div className='col-md-12'>
                  <div className='row'>
                      <div className='col-md-12'>
                      </div>
                  </div>
                 <div className='row'>
                     <div className='col-md-3'>
                        <label><Mandate/>Client</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.client}/>    
                     </div>

                     <div className='col-md-3'>
                        <label><Mandate/>Subclient</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.subclient}/>    
                     </div>
                     <div className='col-md-2'>
                        <label><Mandate/>Budget hours</label><span></span> 
                        <div className='flex' style={{display: 'flex',alignItems: 'center'}}>
                            <input type="text" disabled={true} className='form-control' name="budget_hours" value={adjustmentvalues.budget_hours} />
                            <FaPlus/>
                        </div>
                        
                     </div>
                     
                     <div className='col-md-2'>
                        <label><Mandate/>Add New value</label><span></span> 
                        <input type="text" className='form-control' name="budget_hours2"  onChange={(e) => handlechangeddata(e)}/>
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Wef Date</label><span></span> 
                        <input type="date"  value={adjustmentvalues.date} name="date" onChange={(e) => handlechangeddata(e)} className='form-control' />
                        {/* <Calendar  value={adjustmentvalues.date} name="date" onChange={(e) => handlechangeddata(e)} className='calender-custom-style' /> */}
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Status</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.allowed != 'allowed' ? 'Disabled' : 'Enabled'}/>    
                     </div>
                  </div> 
                  <br/>  
                  

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                           <Button type="submit" label="Save" severity="success" rounded />
                          </span>
                          <span>
                          <Button type="button" onClick={() => setVisibility(false)} stype="button" label="Close" severity="danger" rounded /> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
             </Dialog>
            {/* <div className='card card-custom-style card-style-padding'>
              <div className='row' style={{paddingBottom:'10px'}}>
                    <div className='col-md-3'>
                     <span className="p-input-icon-left pull-left">
                      
                        <FaSearch />
                        <InputText placeholder="Press and Enter"  onKeyDown={(e)=>{searchclients(e)}}/>
                     </span> 
                    </div>
                    <br/>
                </div>
                <br/> 
            </div> */}

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default SubClientmerger;
